import { graphql, useStaticQuery } from "gatsby"

export const useCategoryItems = () => {
  const categoriesData = useStaticQuery(categoriesQuery)
  return categoriesData.allTypo3SubscriptionCategory.nodes
}

export const useCategoryKeys = () => {
  const categoryItems = useCategoryItems()
  return categoryItems.map(item => item.uid.toString())
}

const categoriesQuery = getCategoriesQuery()

function getCategoriesQuery() {
    switch(process.env.TYPE_DEFINITIONS) {
      case "DFB":
        return graphql`
                  query CategoriesQuery {
                    allTypo3SubscriptionCategory {
                      nodes {
                        uid
                      }
                    }
                  }
                `
      default:
        return graphql`
                  query CategoriesQuery {
                    allTypo3SubscriptionCategory {
                      nodes {
                        class
                        uid
                        title
                      }
                    }
                  }
                `
    }
}
